export const enum PermissionType {
  DEFAULT = "Default",
  ADD = "Add",
  VIEW = "View",
  CHANGE = "Change",
  DELETE = "Delete",
  APPROVE = "Approve",
  REJECT = "Reject",
  IMPERSONATION = "Impersonation",
}

export const PERMISSION = {
  DEFAULT: "Default",
  COMMISSION_RULE: "Commission Rule",
  TARGET: "Target",
  PARTNER: "Partner",
  RUN_PAYOUT: "Run Payout",
  PAYOUTS_LOG: "Payouts Log",
  SUBSCRIPTION: "Subscription",
  TRANSACTION: "Transaction",
  OFFLINE_REGISTRATION: "Offline Registration Record",
  MODEL_WISE_CONFIGURATION: "Model Wise Configuration",
  COUPON: "Coupon",
  COUPON_USAGE: "Coupon Usage",
  EMAIL_CREDITS_CONFIGURATION: "Email Credits Configuration",

  STORAGE_PRICE_CONFIGURATION: "Storage Price Configuration",
  GOOGLE_ADS_CONFIGURATION: "Google Ads Margin Configuration",
  USER: "User",
  GROUP: "Group",
  ACTIVITY_LOG: "Activity Log",
  CONTACT: "Contact",
  MESSAGE_CREDIT_CONFIGURATION: "Message Credit Configuration",
  TENANT: "Tenant",
  PLAN: "Plan",
};
